module.exports = __webpack_public_path__ + "img/80.4b1284c1.png";